import { render, staticRenderFns } from "./article-by-categ.vue?vue&type=template&id=29736aee&scoped=true"
import script from "./article-by-categ.vue?vue&type=script&lang=js"
export * from "./article-by-categ.vue?vue&type=script&lang=js"
import style0 from "./article-by-categ.vue?vue&type=style&index=0&id=29736aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29736aee",
  null
  
)

export default component.exports